import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AlertService, PlanLimitAlert } from '../../services/alert.service';
import { AuthService } from '../../services/auth';
import { RoleId } from '../../core/models/role.model';

@Component({
  selector: 'app-plan-limit-alert',
  templateUrl: './plan-limit-alert.component.html',
  styleUrls: ['./plan-limit-alert.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PlanLimitAlertComponent implements OnInit, OnDestroy {
  private _alertService = inject(AlertService);
  private _authService  = inject(AuthService);
  private _sub!: Subscription;

  alert: PlanLimitAlert | null = null;
  visible = false;
  closing = false;

  readonly waLink = 'https://wa.link/l4gjr4';

  get isAdmin(): boolean {
    return this._authService.hasRoleId(RoleId.ADMINISTRADOR);
  }

  ngOnInit(): void {
    this._sub = this._alertService.planLimit$.subscribe((alert) => {
      if (alert) {
        this.alert   = alert;
        this.closing = false;
        this.visible = true;
      }
    });
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  close(): void {
    this.closing = true;
    setTimeout(() => {
      this.visible = false;
      this.closing = false;
      this._alertService.clearPlanLimit();
    }, 250);
  }

  upgrade(): void {
    window.open(this.waLink, '_blank', 'noopener,noreferrer');
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('sw-alert-backdrop')) {
      this.close();
    }
  }
}
